import { useTranslation } from 'react-i18next';
import { Modal, Typography, message } from "antd";

import i18n from "i18next";
const t = (key: string, fallback?: string) => i18n.t(key, fallback || key);
import React, { useState } from "react";
import ConstructionPlan from "../../../mooc-course-construction-plan1/components/ConstructionPlan";
import { TypeCourseConstructionPlan } from "../../../../../types/course-plan-managment/mooc-course-construction-plan";
import { FileDoneOutlined } from "@ant-design/icons";
import { CreareCoursePlanArroval } from "../../../../../types/course-plan-managment/mooc-approval";
import { approvalStatusEum } from "../../constants/data";
import { approveCoursePlan } from "../../../../../service/course-plan-managment/mooc-approval-plan/mooc-approval-plan-api";
import { HelpService } from "../../../../../service/helper.service";
import { get } from "lodash";
import { useAuthStore } from "../../../../../stores/stores";

interface ModalCourseConstructAppraisalProps {
  isOpen: boolean;
  setIsOpen: any;
  dataCourseStructure: any;
  expandAll: any;
  setExpandAll: any;
  expandedKeys: any;
  setExpandedKeys: any;
  courseConstructDetail?: TypeCourseConstructionPlan;
  handleListCourse: () => void;
}

const ModalCourseConstructAppraisal = (
  props: ModalCourseConstructAppraisalProps
) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isOpenModalConfirm, setIsOpenModalConfirm] = useState<boolean>(false);
  const {
    isOpen,
    setIsOpen,
    dataCourseStructure,
    expandAll,
    setExpandAll,
    expandedKeys,
    setExpandedKeys,
    courseConstructDetail,
    handleListCourse,
  } = props;

  const helpService = new HelpService();
  const userId = useAuthStore((states) => states.user?.id);
  const handleCancel = () => {
    setIsOpen(false);
  };
  const handleOk = () => {
    setIsOpenModalConfirm(true);
  };
  const handleCancelConfirm = () => {
    setIsOpenModalConfirm(false);
  };

  const handleOkConfirm = () => {
    const dataSend: CreareCoursePlanArroval = {
      userId: Number(userId),
      courseId: Number(courseConstructDetail?.courseConstructionPlanId),
      organzationId: courseConstructDetail?.organzationId ?? undefined,
      courseStatus: approvalStatusEum.APPROVED,
    };
    approveCoursePlan(dataSend).then((res) => {
      const { data, statusCode } = res.data;
      if (statusCode === 200) {
        handleListCourse();
        message.success(t("Thẩm định nhanh kế hoạch khóa học thành công", "Thẩm định nhanh kế hoạch khóa học thành công"));
        setIsOpen(false);
        setIsOpenModalConfirm(false);
      }
    });
  };
  return (
    <>
      <Modal
        open={isOpen}
        title={`${t("Thẩm định nhanh kế hoạch", "Thẩm định nhanh kế hoạch")} ${courseConstructDetail?.registrationName}`}
        width={900}
        confirmLoading={isLoading}
        centered={true}
        onOk={handleOk}
        okText={t("Thẩm định", "Thẩm định")}
        onCancel={handleCancel}
        cancelText={t("Huỷ", "Huỷ")}
      >
        <ConstructionPlan
          dataCourseStructure={dataCourseStructure}
          expandAll={expandAll}
          setExpandAll={setExpandAll}
          expandedKeys={expandedKeys}
          setExpandedKeys={setExpandedKeys}
        />
      </Modal>

      {isOpenModalConfirm && (
        <Modal
          open={isOpenModalConfirm}
          width={450}
          centered={true}
          onOk={handleOkConfirm}
          okText={t("Thẩm định", "Thẩm định")}
          onCancel={handleCancelConfirm}
          cancelText={t("Huỷ", "Huỷ")}
          closeIcon={""}
        >
          <>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: 35,
              }}
            >
              <FileDoneOutlined
                style={{ color: "#1890FF", marginRight: 12, fontSize: 22 }}
              />
              <Typography.Text
                style={{
                  fontSize: "16px",
                  lineHeight: "24px",
                  fontWeight: "500",
                }}
              >
                {t("Xác nhận thẩm định kế hoạch khoá học", "Xác nhận thẩm định kế hoạch khoá học")}
              </Typography.Text>
            </div>
          </>
        </Modal>
      )}
    </>
  );
};

export default ModalCourseConstructAppraisal;
